import { render, staticRenderFns } from "./ImageTextBanner.vue?vue&type=template&id=23b466ad&scoped=true"
import script from "./ImageTextBanner.vue?vue&type=script&lang=js"
export * from "./ImageTextBanner.vue?vue&type=script&lang=js"
import style0 from "./ImageTextBanner.vue?vue&type=style&index=0&id=23b466ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b466ad",
  null
  
)

export default component.exports